<template>
  <div class="pay_box">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item>
        <el-input v-model="form.name" placeholder="name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.email" placeholder="email"></el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="submitHandle">submit</el-button>
  </div>
</template>

<script>
import {getClientId} from "@/api/organization";
export default {
  name: "pay_test",
  data () {
    // this.publishableKey = process.env.STRIPE_PUBLISHABLE_KEY;
    return {
      form:{
        name:"",
        email:"",
      },
      client_Id:''
    };
  },
  methods: {
     submitHandle(){
      console.log('submit')
      getClientId(this.form).then(async res=>{
          this.client_Id = res.client_secret
      //   const stripe = await stripePromise;
      //     console.log(this.client_Id,'dd')
      //     const { setupIntent, error } = await stripe.confirmAcssDebitSetup(
      //       this.client_Id,
      //       {
      //         payment_method: {
      //           billing_details: {
      //             name: this.form.name,
      //             email: this.form.email,
      //           },
      //         },
      //       }
      //     );
      //
      //     if (error) {
      //       // Inform the customer that there was an error.
      //       console.log(error.message);
      //     } else {
      //       // Handle next step based on SetupIntent's status.
      //       console.log("SetupIntent ID: " + setupIntent.id);
      //       console.log("SetupIntent status: " + setupIntent.status);
      //     }
      })
    }
  },
}
</script>

<style scoped lang="less">
.pay_box{
  width: 500px;
  height: 200px;
}
/deep/.Button--primary{
  background-color: green!important;
}
</style>
